import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SurveyData } from './surveyData';

const routes: Routes = [
  {
    path: 'survey',
    component: SurveyData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyDataRoutingModule {}
